'use client'

import { useState } from 'react'
import StorylineChapters from './StorylineChapters'
import StorylineDayChart from './StorylineDayChart'

// The storyline page below its coverage block (the identity mocks,
// 2026-11-01): the day-by-day chart, then the chapters with the side column
// (`aside`: most active outlets, people and places) beside them on desktop.
// The chart draws the days of the chapters on show: the last twelve, until
// "Earlier chapters" opens the rest (a line at the list's foot on desktop,
// an outlined button on a phone).

const VISIBLE = 12

export default function StorylineBody({
  chapters = [],
  days = [],
  slug,
  aside = null,
  // The chart's window (2026-11-01): every day from `from` to `to`, quiet
  // ones too. Without it the chart draws the days of the chapters on show.
  from = null,
  to = null,
}) {
  const [all, setAll] = useState(false)
  const newest = [...chapters].reverse()
  const shown = all ? newest : newest.slice(0, VISIBLE)
  const onShow = new Set(shown.map((c) => c.day))
  const shownDays = days.filter((d) => onShow.has(d.day))
  const more = !all && newest.length > VISIBLE

  return (
    <>
      <section className="mt-[26px] sm:mt-[46px] sm:border-t sm:border-foreground sm:pt-[26px]">
        <h2 className="mb-1 font-serif text-2xl font-medium sm:text-[28px]">
          Who covered it, day by day
        </h2>
        {from && to ? (
          <StorylineDayChart days={days} from={from} to={to} />
        ) : (
          <StorylineDayChart days={shownDays} />
        )}
      </section>

      <section className="mt-[30px] flex flex-wrap gap-11 pb-9 sm:mt-12 sm:border-t sm:border-foreground sm:pb-0 sm:pt-[26px]">
        <div className="min-w-0 flex-[999_1_560px]">
          <h2 className="mb-1 font-serif text-2xl font-medium sm:mb-1.5 sm:text-[28px]">
            Chapters
          </h2>
          <StorylineChapters chapters={shown} slug={slug} />
          {more && (
            <>
              <p className="mt-3.5 hidden font-sans text-[13px] text-muted-foreground sm:block">
                Showing the last {shownDays.length}{' '}
                {shownDays.length === 1 ? 'day' : 'days'} ·{' '}
                <button
                  type="button"
                  onClick={() => setAll(true)}
                  className="underline transition-colors hover:text-foreground"
                >
                  Earlier chapters
                </button>
              </p>
              <button
                type="button"
                onClick={() => setAll(true)}
                className="mt-4 flex min-h-12 w-full items-center justify-center rounded-lg border border-foreground font-sans text-sm font-semibold text-foreground sm:hidden"
              >
                Earlier chapters
              </button>
            </>
          )}
        </div>
        {/* The phone mock stacks only the chart and the chapters; the side
            column is desktop's. */}
        {aside && (
          <aside className="min-w-0 flex-[1_1_300px] max-sm:hidden">
            {aside}
          </aside>
        )}
      </section>
    </>
  )
}
